var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.8 71.5",
    style: {
      enableBackground: "new 0 0 100.8 71.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FE9F07;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,31.7c0-2.1,0-4.1,0-6.2c0-0.6-0.1-1.3,0.6-1.6c0.5-0.2,1,0.3,1.4,0.6c3,2.5,5.8,5.1,8.9,7.4 c4.9,3.6,12,1.4,14-4.2c1.4-3.8-0.2-8.1-4.2-9.9c-2.7-1.2-3.2-2.9-3.1-5.4c0.1-5.1,1.1-5.9,5.9-3.9c6.3,2.6,10.2,7.3,11.2,14.1 c0.2,1.3,0.5,1.4,1.7,1.1c10.3-2.7,19.8,4.8,20.2,13.8c0.1,1.4,0.4,2.7,0.8,4.1c0.8,3.1,2.5,4.3,5.4,4.3c2.9,0,4.7-1.3,5.7-4.2 c0.5-1.5,0.6-3.2,0.6-4.8c0-1.8,0.9-2.6,2.7-2.7c6.6-0.5,7.4,0.3,6.2,6.8c-0.2,0.9-0.3,1.8-0.6,2.7c-3.1,10.9-15.5,14.8-24.4,7.6 c-0.9-0.8-1.4-0.8-2.5-0.1c-9.4,7-22.2,2.6-25.3-8.6c-0.4-1.5-0.8-1.7-2.3-1.1c-4.3,1.6-8.6,1.6-12.9-0.1c-1.4-0.5-1.7-0.3-2,1.2 C28,54.6,18.5,56.4,10.5,54.2C6,53,3.2,49.8,1.9,45.6c-2.1-6.4-2-13-1.7-19.6c0.1-1.6,1-2.2,2.6-2.3c6.9-0.4,6.9-0.3,6.8,6.4 c-0.1,3.7-0.4,7.4,0.5,11c0.8,3.4,2.7,5,5.7,5.1c3,0.1,5.1-1.7,6-5.1C22.4,38,22.2,34.9,22.2,31.7L22.2,31.7z M63,46.3 c4.1,0,7.4-3.2,7.4-7.2c0-4.1-3.3-7.5-7.4-7.5c-4.1,0-7.5,3.4-7.4,7.5C55.6,43.1,58.9,46.3,63,46.3L63,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.1,12.8c0.2,2.2-0.2,4.2-3.2,5.3c-2.2,0.8-3.5,3-4,5.3c-0.4,1.7-1.1,1.8-2.4,0.9c-4.3-2.7-4.8-4.6-2.1-9 c2-3.3,4.7-5.7,8.3-6.9c2.7-0.9,3.3-0.5,3.4,2.3C35.1,11.3,35.1,11.8,35.1,12.8L35.1,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,24.1c0.7,0,1.4,0,2.1,0c0.4,0,0.8,0,1.1,0.2c2.7,1.5,1.3,4.1,1.5,6.2c0.1,1.5-0.7,2.5-2.4,2.5 c-0.4,0-0.8,0.1-1.2,0.1c-5.6,0.3-6.2-0.3-5.9-5.7C89.4,24.3,89.9,24,94,24.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.79c9f62db6a34dfc04769e07f3072372.svg";
export { ForwardRef as ReactComponent };